<template>
  <div>
    
    <Head title="DASHBOARD - EMPRESA" />
    <div class="w-full p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase lg:w-6/12">
        DASHBOARD - EMPRESA {{ company.name }} - ({{ company.cnpj }})
      </h1>
  
      <button
        class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full lg:w-2/12"
        @click.prevent="gerarPDF"
      >
        <font-awesome-icon
          icon="fa-file-pdf"
          class="text-purple text-sm mr-0 lg:mr-2"
        />Baixar PDF
      </button>
      <div id="pdf_company" class="w-full" style="padding: 25px;">
        <div class="header">
          <table>
            <tr>
              <td colspan="3">
                <div class="title">
                  {{ company.name }}
                </div>
                
              </td>
            </tr>
            <tr class="sub_title">
                <td style="width:20%">{{ company.cnpj }}</td>
                <td style="width:20%">{{ company.contact }}</td>
                <td style="text-align: left;">{{ company.email }}</td>
            </tr>
          </table>
        </div>
        
        
        <div class="label" style="margin-top: 20px;">Quantidade de consultas com Clínico Geral:
          {{ company.qtdConsultasClinGeral }}</div>
        <div class="label" style="margin-top: 20px;">Quantidade de funcionários ativos: {{ company.qtdFuncionariosAtivos }}</div>
        <div class="label" style="margin-top: 20px;">Quantidade de funcionários inativos: {{ company.qtdFuncionariosInativos }}
        </div>
        <div class="label" style="margin-top: 20px;">Quantidade de dependentes: {{ company.qtdDependentes }}</div>
        <div class="label" style="margin-top: 20px;">Quantidade de consultas com especialistas:
          {{ company.qtdConsultasEspecialistas }}</div>
        <div class="label" style="margin-top: 20px;">Quantidade de exames solicitados: {{ company.qtdExames }}</div>
        <div class="label" style="margin-top: 20px;">Quantidade de atestados gerados: {{ company.qtdAtestadosGerados }}</div>
        <div class="label" style="margin-top: 20px;">Percentual de utilização das consultas por dependentes:
          {{ company.percentualUtilizacaoDependentes }} %</div>
        <div class="label" style="margin-top: 20px;">Taxa de utilização dos alarmes de medicamentos e água:
          {{ company.taxaAlarmesAgua }}</div>
        <div class="label" style="margin-top: 20px;">Custo total do plano: R$ {{ company.custoTotalPlano }}</div>

        
        <div v-if="company.dados_atendimentos" style="margin-top: 40px;">
            <h4 style="font-weight: bold; color: silver;">RELATÓRIO DE ATENDIMENTO</h4>
        </div>
        <div v-if="company.dados_atendimentos">
            <div v-for="(dado_atendimento, dado_atendimento_index) in company.dados_atendimentos" :key="dado_atendimento_index">
                <table style="width:100%; margin-top: 10px; font-size: 13px;">
                    <tr style="">
                        <td style="width:50%;">
                            <strong>{{ dado_atendimento.namePatient }}</strong>
                        </td>
                        <td style="width:50%; text-align: right;"><span><strong>Valor Total:</strong> {{ dado_atendimento.valueTotal }}</span> </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <table v-if="dado_atendimento.atendimentos"
                                    style="width: 100%; border-bottom: 1px solid silver; border-top: 1px solid silver; margin-top: 10px;">
                                    <tr style="border-bottom: 1px solid silver; border-spacing: 1px;">
                                        <td style="padding: 5px;">
                                            <strong>Especialidade</strong>
                                        </td>
                                        <td style="padding: 5px;">
                                            <strong>Quantidade de atendimentos</strong>
                                        </td>
                                        <td style="padding: 5px;">
                                            <strong>Valor</strong>
                                        </td>
                                    </tr>
                                    <tr v-for="(atendimento, atendimento_index) in dado_atendimento.atendimentos" :key="atendimento_index">
                                                <td style="padding: 5px;">{{ atendimento.especiliadade }}</td>
                                                <td style="padding: 5px;">{{ atendimento.quantidade }}</td>
                                                <td style="padding: 5px;">{{ atendimento.valor }}</td>
                                            </tr>
                                        
                                </table>
                            
                        </td>
                    </tr>
                </table>

            </div>
        </div>

        <div style="margin-top: 40px;  ">
            <h4 style="font-weight: bold; color: silver;">ANÁLISE DOS PLANOS DE ASSINATURA EM RELAÇÃO AO NÚMERO DE
                FUNCIONÁRIOS</h4>
        </div>

        <div class="mb-10 w-full lg:w-5/12">            
            <div>
                <doughnut-chart class="my-6" :chart-data="this.chartDoughnutData()"/>
            </div>

        </div>

        
        
          
          
      </div>
        
             
    </div>
  </div>
</template>
<style>
      body {
      font-family: sans-serif;
      font-size: 16px;
      }

      .header{
        border-bottom: 1px solid silver;
    padding-bottom: 10px;
    padding-top: 10px;
      }

      .title {
      text-transform: uppercase;
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 26px;
      }

      .sub_title{
        
        font-size: 14px;

      }

      .field {
      display: inline-block;
      }

      .margin-fields {
      margin-top: 5px;
      }

      .label {
      font-weight: bold;
      font-size: 13px;
      }

      .description {
      padding: 10px;
      }

      .footer {
      width: 100%;
      position: fixed;
      bottom: 0px;
      }

      .signature {
      margin-top: 30px;
      }

      .signature_box {
      border: 1px solid black;
      width: 50%;
      height: 80px;
      margin: 0 auto;
      }

      .signature_text {
      text-transform: uppercase;
      text-align: center;
      margin-top: 10px;
      }

      .logo {
      max-width: 100px;
      }

      .header table {
      width: 100%;
      }

      .header table tr td:first-of-type,
      .header table tr td:last-of-type {
      width: 5%;
      }

      .pie-chart {
      width: 600px;
      height: 150px;
      margin: 0 auto;
      }

      .text-center {
      text-align: center;
      }
    </style>
    
<script>
import { computed } from 'vue';
import { Head, usePage, useForm } from '@inertiajs/inertia-vue3';
import starRating from 'vue-star-rating';
  
import Layout from '@/Shared/Layout/Layout';
import LineChart from '@/Shared/Components/LineChart';
import DoughnutChart from '@/Shared/Components/DoughnutChart';
import ProgressChart from '@/Shared/Components/ProgressChart';
  
import SelectInput from '@/Shared/Fields/SelectInput';
import DateMonthInput from '@/Shared/Fields/DateMonthInput';
import VBarChart from '@/Shared/Components/VBarChart';
  
import Tabs from '@/Shared/Components/Tabs/Tabs';
  
import Modal from '@/Shared/Modal/Modal';
import DataTable from '@/Shared/Components/DataTable';
import axios from 'axios';
import html2pdf from 'html2pdf.js';

  
export default {
  components: {
    computed,
    usePage,
    axios,
    Head,
    LineChart,
    DoughnutChart,
    ProgressChart,
    Tabs,
    SelectInput,
    DateMonthInput,
    VBarChart,
    starRating,
    DataTable,
    Modal,
  },
  props: {
      
    totalDay: 0,
    totalMonth: 0,
    totalEmployees: 0,
    totalEmployeesUp: 0,
    totalEmployeesDown: 0,
    totalApointiments: 0,
    totalEmployeesBasic: 0,
    totalEmployeesMedium: 0,
    totalEmployeesPremium: 0,
    totalBySpecialty: Object,
    totalByMonth: Object,
    specialty: Array,
    company: Object,
    listCount: 0,
  },
  provide() {
    return {};
  },
  
  data() {
    return {
      patient: null,
      selectedItemIndex: 0,
      barChartFilters: {
        date: null,
        selectedChartView: 'profitability',
      },
      chartBarData: null,
      chartDoughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 150,
        plugins: {
          legend: {
            position: 'bottom',
          },
        },
      },
      loadTable: this.listCount > 0,
      columns: [
        {
          uniqid: 'apoint_nameUser',
          label: 'Médico',
          field: 'nameUser',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.nameUser}`,
        },
        {
          uniqid: 'apoint_nameSpeaciality',
          label: 'Especialidade',
          field: 'nameSpeaciality',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.nameSpeaciality}`,
        },
        {
          uniqid: 'apoint_total',
          label: 'Qtd de Atendimentos',
          field: 'total',
          visible: true,          
          classes:
              'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.total}`,
        },
      ],
    };
  },
  layout: Layout,
  
  mounted() {
    const date = new Date();
  
    this.barChartFilters.date = `${date.getFullYear()}-${date.getMonth() + 1}`;
      
  
  },
  
  computed: {
    titleChart() {
      return this.barChartFilters.selectedChartView == 'profitability'
        ? 'Rentabilidade Mensal'
        : 'Quantidade de Atendimentos';
    },
  
    legendMonth() {
      return this.barChartFilters.selectedChartView == 'profitability'
        ? 'Lucro do mês atual'
        : 'Atendimentos do mês atual';
    },
  
    legendYear() {
      return this.barChartFilters.selectedChartView == 'profitability'
        ? 'Lucro do ano atual'
        : 'Atendimentos do ano atual';
    },
  
    chartLabel() {
      return this.barChartFilters.selectedChartView == 'profitability'
        ? 'Lucro'
        : 'Atendimentos';
    },
  
    monthDate() {
      const dateSplited = this.barChartFilters.date.split('-');
      const date = new Date(dateSplited[0], Number(dateSplited[1]) - 1);
  
      return (
        date.toLocaleDateString('pt-BR', { month: 'long' }) +
          '/' +
          date.getFullYear()
      );
    },
  
    yearDate() {
      return this.barChartFilters.date.split('-')[0];
    },
  },
  
  watch: {
    'barChartFilters.selectedChartView': function () {},
  
    'barChartFilters.date': function () {},
  },
  
  methods: {
    chartDoughnutData() {
      let labels = [];
      let colors = [];
      let values = [];
      labels.push('Plano Básico');
      labels.push('Plano Médio');
      labels.push('Plano Premium');
      colors.push('#6594c4');
      colors.push('#374c69');
      colors.push('#cbbc7e');
      values.push(this.company.totalEmployeesBasic);
      values.push(this.company.totalEmployeesMedium);
      values.push(this.company.totalEmployeesPremium);
      
  
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: colors,
            data: values,
          },
        ],
      };
    },
      
    gerarPDF() {
      html2pdf(document.getElementById('pdf_company'), {
        margin: 1,
        filename: 'dashboard.pdf',
      });
    },
    openWindowWithPost(url, data) {
      axios
        .post(`/companies-dashboard/generate/${this.company.id}`, {
            
        })
        .then((response) => {
          console.log(response.data)
          var base64EncodedPDF = response.data;
          var dataURI = 'data:application/pdf;base64,' +base64EncodedPDF;
          window.open(dataURI);
        })
        .catch((error) => {
          console.log(error);
        });
  
      // form.submit();
      //document.body.removeChild(form);
    },
    generateInput(form, key, value) {
      if (typeof value == 'object' && value != null) {
        for (const [obj_key, obj_value] of Object.entries(value)) {
          let k = key + '|' + obj_key;
          this.generateInput(form, k, obj_value);
        }
      } else {
        let k = key.split('|');
        if (k.length > 1) {
          for (let i in k) {
            if (i == 0) {
              key = k[i];
            } else {
              key += '[' + k[i] + ']';
            }
          }
        }
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = typeof value != 'undefined' && value != null ? value : '';
        form.appendChild(input);
      }
    },
  },
};
</script>
    